<template lang="pug">
  div.row
    div.col-10
      div.summary-layout
        table.table.table-fixed
          thead.thead-light
            tr
              th 伺服器電腦時間
              th 入口電腦時間
              th 出口電腦時間
              th 同步結果
          tbody
            tr(v-for="data in filteredData")
              td {{ data.server }}
              td {{ data.cmp1_time}}
              td {{ data.cmp2_time}}
              td {{ data.check_status}}
    div.col-2
      QueryFilter(
        v-on:filter="filter"
        :showReportButton="showReportButton"
        :showDate="showDate"
        :showStartDate="showStartDate"
        v-on:report="downloadReport"
      )
      Loader(v-if="loadingData") 
        h4 資料載入中，請稍等
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import FileSaver from 'file-saver';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server, { webSocketServer } from '@/config';
import QueryFilter from './QueryFilter';
import Loader from '../../common/Loader';


Vue.component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  template: `
    <div>{{ rowData.employee_name }}</div>
  `,
});


export default {
  name: 'TimeSyncSummary',
  data() {
    return {
      showStartDate: true,
      showDate: false,
      showReportButton: false,
      moreParams: {},
      loadingData: false,
      fixed_link_code_id: undefined,
      Params: {
        start_date: undefined,
        //end_date: undefined,
      },
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      fields: [
      ],
      server,
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined,
      filteredData: [],
      isOldType: false,
    };
  },
  created() {
    this.fixed_link_code_id= this.$store.state.user.user.department.fixed_link_code;
    this.Params.start_date = moment().format('YYYY-MM-DD');
    //this.Params.end_date = moment().format('YYYY-MM-DD');
    console.log('this.fixed_link_code_id:',this.fixed_link_code_id);
    this.filter(this.Params);
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  components: {
    Vuetable,
    VuetablePagination,
    QueryFilter,
    Loader,
  },
  methods: {
    downloadReport(params) {
      if (params.start_date == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢日期',
        });
        return;
      }
      window.open(`${server}/download1236/download-sync-report/?fid=${this.$store.state.user.user.department.fixed_link_code}&start=${params.start_date}`, '_blank');
    },
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate(value) {
      return moment(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    filter(params) {
      if(this.loadingData==false){
        this.loadingData=true;
        this.Params.start_date=params.start_date;
        this.filteredData = [];
        this.instance.get(`${server}/api/time-sync-log/`, {
          params: {
            start_date: this.Params.start_date,
            fixed_link_code_id: this.fixed_link_code_id,
          },
        })
        .then((res) => {
          console.log(res);
          res.data.forEach((item) => {
            item.server = this.readableDate(item.server);
            item.cmp1_time = this.readableDate(item.cmp1_time);
            item.cmp2_time = this.readableDate(item.cmp2_time);
            if(this.fixed_link_code_id==8 || this.fixed_link_code_id==9) {
              item.cmp3_time = this.readableDate(item.cmp3_time);
            }
            this.filteredData.push(item);
          });
          //this.$refs.vuetable.setData(filteredData);
          this.loadingData=false;
        })
        .catch((err) => {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '無法取得電腦設備同步確認資料',
          });
          this.loadingData=false;
        });
      }
    },
    connectWebSocket() {
      return new Promise((resolve, rejects) => {
        const wb = new WebSocket(`${webSocketServer}/download-report/${this.$store.state.user.user.id}`);
        wb.onopen = () => {
          this.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = (res) => {
          const data = JSON.parse(res.data);
          if (data.error) {
            this.$store.commit('CLOSE_MESSAGE');
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error,
            });
          }

          if (data.progress !== undefined) {
            this.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            this.instance.get(data.download_path, { responseType: 'blob' })
            .then((res) => {
              FileSaver.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              this.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功',
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = () => { rejects(wb); };
      });
    },
    report(params) {
      params.function_name = 'export_event_table';
      this.connectWebSocket().then((ws) => {
        ws.send(JSON.stringify(params));
      })
      .catch((ws) => {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    },
  },
  watch: {
    downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: `
        <h6>產生報告中</h6>
        <div class="progress">
          <div class="progress-bar progress-bar-striped" 
            role="progressbar" 
            style="width: ${val}%; background-color: #117a8b" 
            aria-valuenow="${val}" 
            aria-valuemin="0" 
            aria-valuemax="100">
          </div>
        </div>
        `,
        type: 'clean',
        confirm: false,
      });
    },
  },
};
</script>

<style lang="sass">
.page-active
  background-color: #0056b3
  color: white !important
  &:hover
    background-color: #0056b3

</style>



// WEBPACK FOOTER //
// TimeSyncSummary.vue?5a4bc30d